// extracted by mini-css-extract-plugin
export default {"mytr":"OtpHistoryCard_mytr__s3UGL"};